export default {
    label_task:{
        en:"Users",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New user",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit user",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of user",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_username:{
        en:"Username",
        bn:"ইউজার নেম"
    },
    label_employee_id :{
        en:"Employee ID",
        bn:"কর্মচারী আইডি"
    },
    label_password:{
        en:"Password",
        bn:"পাসওয়ার্ড"
    },
    label_user_group_id :{
        en:"User Group",
        bn:"ব্যবহারকারী দল"
    },
    label_user_group_name :{
        en:"User Group",
        bn:"ব্যবহারকারী দল"
    },
    label_user_type_name :{
        en:"User Type",
        bn:"ব্যবহারকারী ধরন"
    },
    label_title_authentication :{
        en:"Username,Password, Status",
        bn:"ইউজারনেম, পাসওয়ার্ড, স্ট্যাটাস"
    },
    label_title_identification :{
        en:"Personal Information",
        bn:"ব্যক্তিগত তথ্য"
    },
    label_max_logged_browser :{
        en:"Maximum Allowed Browser",
        bn:"সর্বাধিক অনুমোদিত ব্রাউজার"
    },
    label_mobile_authentication_off_end :{
        en:"Mobile authentication off",
        bn:"মোবাইল যাচাইকরণ বন্ধ"
    },
    label_trial_station_ids  :{
        en:"Trial Station",
        bn:"মোবাইল যাচাইকরণ বন্ধ"
    },
    label_assign_location:{
        en:"Change Location",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_part_id:{
        en:"Part",
        bn:"কর্মচারী আইডি"
    },
    label_part_name:{
        en:"Part",
        bn:"কর্মচারী আইডি"
    },
    label_area_id:{
        en:"Area",
        bn:"কর্মচারী আইডি"
    },
    label_area_name:{
        en:"Area",
        bn:"কর্মচারী আইডি"
    },
    label_territory_id:{
        en:"Territory",
        bn:"কর্মচারী আইডি"
    },
    label_territory_name:{
        en:"Territory",
        bn:"কর্মচারী আইডি"
    },
}